import CoinTable from './CoinTable'
import withCoinTable from './withCoinTable'

const ConnectedCoinTable = withCoinTable(CoinTable)
export { ConnectedCoinTable as CoinTable }
